import { createApp } from 'vue';
import App from './app.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import { getLocalOrDefaultLang, getLangFromUrlParam, key } from './store/util';
import { TroisJSVuePlugin } from 'troisjs';
import { createI18n } from 'vue-i18n';
import { currencyEnUS, en } from './locales/en-US';
import { currencySlSI, sl } from './locales/sl-SI';
import { currencyDeDE, de } from './locales/de-DE';
import { currencyItIT, it } from './locales/it-IT';

// Importing the global css file
import '@/assets/style.scss';

import { Steps, Collapse, Switch, Button, Input, Form, Checkbox, Radio, Spin, Tooltip } from 'ant-design-vue';

const i18n = createI18n({
  locale: getLangFromUrlParam(),
  fallbackLocale: 'sl-SI',
  messages: {
    'en-US': en,
    'sl-SI': sl,
    'de-DE': de,
    'it-IT': it
  },
  numberFormats: {
    'en-US': currencyEnUS,
    'sl-SI': currencySlSI,
    'de-DE': currencyDeDE,
    'it-IT': currencyItIT,
  }
});

createApp(App)
  .use(store, key)
  .use(router)
  .use(TroisJSVuePlugin)
  .use(Steps)
  .use(Collapse)
  .use(Switch)
  .use(Button)
  .use(Input)
  .use(Form)
  .use(Checkbox)
  .use(Radio)
  .use(Spin)
  .use(Tooltip)
  .use(i18n)
  .mount('#app');

